// Plot geometry for the analemma SVG.
export const W = 420;
export const H = 520;
export const PAD = { top: 24, right: 24, bottom: 36, left: 44 };

const X_MIN = -17; // minutes
const X_MAX = 17;
const Y_MIN = -24; // degrees
const Y_MAX = 24;

export const sx = (eot: number) => PAD.left + ((eot - X_MIN) / (X_MAX - X_MIN)) * (W - PAD.left - PAD.right);
export const sy = (dec: number) => PAD.top + ((Y_MAX - dec) / (Y_MAX - Y_MIN)) * (H - PAD.top - PAD.bottom);

export const SANS = "Inter, sans-serif";
export const SERIF = "'Fraunces Variable', serif";
export const MUTED = "#8a6f52";
export const signed = (n: number, unit: string) => `${n > 0 ? "+" : ""}${n}${unit}`;
